import { render, staticRenderFns } from "./polling.vue?vue&type=template&id=038e0e11&scoped=true&"
import script from "./polling.vue?vue&type=script&lang=js&"
export * from "./polling.vue?vue&type=script&lang=js&"
import style0 from "./polling.vue?vue&type=style&index=0&id=038e0e11&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e0e11",
  null
  
)

component.options.__file = "polling.vue"
export default component.exports